class AmmCloneHeader extends HTMLElement {
  connectedCallback() {
    if (this.ammCloneInitialized) return;
    this.ammCloneInitialized = true;

    this.ammCloneDrawer = this.querySelector("[data-amm-clone-drawer]");
    this.ammCloneDrawerTrigger = this.querySelector("[data-amm-clone-drawer-open]");
    this.ammCloneSection = this.closest(".shopify-section");
    this.ammCloneLastFocus = null;
    this.ammCloneScrollY = window.scrollY;
    this.ammCloneScrollTicking = false;
    this.ammCloneMegaCloseTimers = new Map();

    this.ammCloneOnClick = this.ammCloneHandleClick.bind(this);
    this.ammCloneOnKeydown = this.ammCloneHandleKeydown.bind(this);
    this.ammCloneOnPointerOver = this.ammCloneHandlePointerOver.bind(this);
    this.ammCloneOnPointerOut = this.ammCloneHandlePointerOut.bind(this);
    this.ammCloneOnFocusIn = this.ammCloneHandleFocusIn.bind(this);
    this.ammCloneOnScroll = this.ammCloneHandleScroll.bind(this);
    this.ammCloneOnResize = this.ammCloneUpdateHeaderPosition.bind(this);
    this.ammCloneOnLoad = this.ammCloneUpdateHeaderPosition.bind(this);
    this.ammCloneTransparentOffset = 0;

    this.addEventListener("click", this.ammCloneOnClick);
    document.addEventListener("keydown", this.ammCloneOnKeydown);
    this.addEventListener("pointerover", this.ammCloneOnPointerOver);
    this.addEventListener("pointerout", this.ammCloneOnPointerOut);
    this.addEventListener("focusin", this.ammCloneOnFocusIn);
    window.addEventListener("scroll", this.ammCloneOnScroll, { passive: true });
    window.addEventListener("resize", this.ammCloneOnResize, { passive: true });
    window.addEventListener("load", this.ammCloneOnLoad, { once: true, passive: true });
    window.addEventListener("pageshow", this.ammCloneOnLoad, { passive: true });

    this.ammCloneSection?.classList.toggle(
      "amm-clone-header-section--sticky",
      this.dataset.ammCloneSticky !== "none"
    );
    this.ammCloneSection?.classList.toggle(
      "amm-clone-header-section--transparent",
      this.dataset.ammCloneTransparent === "true"
    );

    this.ammCloneSetCountryFlag();
    this.ammCloneEnsureCartCounts();
    this.ammCloneSetupOffsetObserver();
    this.ammCloneUpdateHeaderPosition();
    requestAnimationFrame(() => this.ammCloneUpdateHeaderPosition());
    window.setTimeout(() => this.ammCloneUpdateHeaderPosition(), 250);

    if (window.customElements?.whenDefined) {
      window.customElements.whenDefined("m-cart-count").then(() => this.ammCloneEnsureCartCounts());
    }
  }

  ammCloneSetCountryFlag() {
    this.querySelectorAll("[data-amm-clone-country-flag]").forEach((flag) => {
      const code = (flag.dataset.countryCode || "").trim().toUpperCase();
      if (!/^[A-Z]{2}$/.test(code)) return;
      flag.textContent = [...code]
        .map((character) => String.fromCodePoint(127397 + character.charCodeAt(0)))
        .join("");
    });
  }

  ammCloneEnsureCartCounts() {
    const sourceCount = document.querySelector("m-cart-count, .m-cart-count");
    const countText = (sourceCount?.textContent || "0").trim() || "0";
    const countNumber = Number.parseInt(countText, 10) || 0;

    this.querySelectorAll(".m-cart-icon-bubble").forEach((cartLink) => {
      if (cartLink.querySelector("m-cart-count")) return;

      const count = document.createElement("m-cart-count");
      count.className = "m-cart-count-bubble m-cart-count amm-clone-header__cart-count m:font-bold";
      if (countNumber === 0) count.classList.add("m:hidden");
      count.textContent = countNumber > 99 ? "99+" : String(countNumber);
      cartLink.appendChild(count);
    });
  }

  disconnectedCallback() {
    if (!this.ammCloneInitialized) return;
    this.removeEventListener("click", this.ammCloneOnClick);
    document.removeEventListener("keydown", this.ammCloneOnKeydown);
    this.removeEventListener("pointerover", this.ammCloneOnPointerOver);
    this.removeEventListener("pointerout", this.ammCloneOnPointerOut);
    this.removeEventListener("focusin", this.ammCloneOnFocusIn);
    window.removeEventListener("scroll", this.ammCloneOnScroll);
    window.removeEventListener("resize", this.ammCloneOnResize);
    window.removeEventListener("load", this.ammCloneOnLoad);
    window.removeEventListener("pageshow", this.ammCloneOnLoad);
    this.ammCloneMegaCloseTimers?.forEach((timer) => window.clearTimeout(timer));
    this.ammCloneMegaCloseTimers?.clear();
    this.ammCloneOffsetObserver?.disconnect();
    this.ammCloneOffsetObserver = null;
    this.ammCloneSection?.classList.remove(
      "amm-clone-header-section--sticky",
      "amm-clone-header-section--transparent",
      "amm-clone-header-section--scrolled"
    );
    this.ammCloneInitialized = false;
  }

  ammCloneHandleClick(event) {
    const openDrawer = event.target.closest("[data-amm-clone-drawer-open]");
    const closeDrawer = event.target.closest("[data-amm-clone-drawer-close]");
    const openSubmenu = event.target.closest("[data-amm-clone-submenu-open]");
    const backSubmenu = event.target.closest("[data-amm-clone-submenu-back]");
    const searchTrigger = event.target.closest("[data-open-search-popup]");

    if (openDrawer) {
      event.preventDefault();
      this.ammCloneOpenDrawer(openDrawer);
      return;
    }

    if (closeDrawer) {
      event.preventDefault();
      this.ammCloneCloseDrawer();
      return;
    }

    if (openSubmenu) {
      event.preventDefault();
      this.ammCloneOpenSubmenu(openSubmenu);
      return;
    }

    if (backSubmenu) {
      event.preventDefault();
      this.ammCloneCloseSubmenu(backSubmenu.closest("[data-amm-clone-submenu]"));
      return;
    }

    if (searchTrigger && this.ammCloneDrawer && !this.ammCloneDrawer.hidden) {
      this.ammCloneCloseDrawer(false);
    }
  }

  ammCloneHandlePointerOver(event) {
    if (!window.matchMedia("(min-width: 1024px)").matches) return;
    const item = event.target.closest("[data-amm-clone-menu-item]");
    if (item) this.ammCloneCancelMegaClose(item);

    const trigger = event.target.closest("[data-amm-clone-mega-trigger]");
    if (trigger) this.ammCloneOpenMega(trigger);
  }

  ammCloneHandlePointerOut(event) {
    if (!window.matchMedia("(min-width: 1024px)").matches) return;
    const item = event.target.closest("[data-amm-clone-menu-item]");
    if (!item || item.contains(event.relatedTarget)) return;
    this.ammCloneScheduleMegaClose(item);
  }

  ammCloneHandleFocusIn(event) {
    const item = event.target.closest("[data-amm-clone-menu-item]");
    if (item) this.ammCloneCancelMegaClose(item);

    const trigger = event.target.closest("[data-amm-clone-mega-trigger]");
    if (trigger && window.matchMedia("(min-width: 1024px)").matches) {
      this.ammCloneOpenMega(trigger);
    }
  }

  ammCloneHandleKeydown(event) {
    const trigger = event.target.closest("[data-amm-clone-mega-trigger]");
    if (trigger && (event.key === "ArrowDown" || event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      this.ammCloneOpenMega(trigger);
      const mega = this.querySelector(`#${CSS.escape(trigger.getAttribute("aria-controls"))}`);
      mega?.querySelector("a")?.focus();
      return;
    }

    if (event.key === "Escape") {
      const openSubmenu = [...this.querySelectorAll("[data-amm-clone-submenu]:not([hidden])")].pop();
      if (openSubmenu && this.ammCloneDrawer && !this.ammCloneDrawer.hidden) {
        event.preventDefault();
        this.ammCloneCloseSubmenu(openSubmenu);
        return;
      }

      if (this.ammCloneDrawer && !this.ammCloneDrawer.hidden) {
        event.preventDefault();
        this.ammCloneCloseDrawer();
        return;
      }

      const openItem = this.querySelector(".amm-clone-header__nav-item--open");
      if (openItem) {
        event.preventDefault();
        const openTrigger = openItem.querySelector("[data-amm-clone-mega-trigger]");
        this.ammCloneCloseMega(openItem);
        openTrigger?.focus();
      }
    }

    if (event.key === "Tab" && this.ammCloneDrawer && !this.ammCloneDrawer.hidden) {
      this.ammCloneTrapFocus(event);
    }
  }

  ammCloneCancelMegaClose(item) {
    const timer = this.ammCloneMegaCloseTimers?.get(item);
    if (timer === undefined) return;
    window.clearTimeout(timer);
    this.ammCloneMegaCloseTimers.delete(item);
  }

  ammCloneScheduleMegaClose(item) {
    this.ammCloneCancelMegaClose(item);
    const timer = window.setTimeout(() => {
      this.ammCloneMegaCloseTimers.delete(item);
      this.ammCloneCloseMega(item);
    }, 350);
    this.ammCloneMegaCloseTimers.set(item, timer);
  }

  ammCloneOpenMega(trigger) {
    const item = trigger.closest("[data-amm-clone-menu-item]");
    this.ammCloneCancelMegaClose(item);
    this.querySelectorAll("[data-amm-clone-menu-item]").forEach((candidate) => {
      if (candidate !== item) this.ammCloneCloseMega(candidate);
    });
    item?.classList.add("amm-clone-header__nav-item--open");
    trigger.setAttribute("aria-expanded", "true");
    this.classList.add("amm-clone-header--menu-open");
  }

  ammCloneCloseMega(item) {
    this.ammCloneCancelMegaClose(item);
    item?.classList.remove("amm-clone-header__nav-item--open");
    item?.querySelector("[data-amm-clone-mega-trigger]")?.setAttribute("aria-expanded", "false");
    if (!this.querySelector(".amm-clone-header__nav-item--open")) {
      this.classList.remove("amm-clone-header--menu-open");
    }
  }

  ammCloneOpenDrawer(trigger) {
    if (!this.ammCloneDrawer || !this.ammCloneDrawer.hidden) return;
    this.ammCloneLastFocus = trigger || document.activeElement;
    this.ammCloneDrawer.hidden = false;
    this.ammCloneDrawer.setAttribute("aria-hidden", "false");
    trigger?.setAttribute("aria-expanded", "true");
    document.documentElement.classList.add("amm-clone-header-no-scroll");
    requestAnimationFrame(() => {
      this.ammCloneDrawer.classList.add("amm-clone-header__drawer--open");
      this.ammCloneDrawer.querySelector(".amm-clone-header__drawer-panel")?.focus();
    });
  }

  ammCloneCloseDrawer(restoreFocus = true) {
    if (!this.ammCloneDrawer || this.ammCloneDrawer.hidden) return;
    this.ammCloneDrawer.classList.remove("amm-clone-header__drawer--open");
    this.ammCloneDrawer.setAttribute("aria-hidden", "true");
    this.ammCloneDrawerTrigger?.setAttribute("aria-expanded", "false");
    document.documentElement.classList.remove("amm-clone-header-no-scroll");

    this.querySelectorAll("[data-amm-clone-submenu]").forEach((submenu) => {
      submenu.hidden = true;
    });
    this.querySelectorAll("[data-amm-clone-submenu-open]").forEach((button) => {
      button.setAttribute("aria-expanded", "false");
    });

    window.setTimeout(() => {
      this.ammCloneDrawer.hidden = true;
      if (restoreFocus) this.ammCloneLastFocus?.focus();
    }, window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 280);
  }

  ammCloneOpenSubmenu(trigger) {
    const id = trigger.getAttribute("aria-controls");
    const submenu = id ? this.querySelector(`#${CSS.escape(id)}`) : null;
    if (!submenu) return;
    submenu.hidden = false;
    trigger.setAttribute("aria-expanded", "true");
    submenu.dataset.ammCloneReturnFocus = id;
    submenu.querySelector("[data-amm-clone-submenu-back]")?.focus();
  }

  ammCloneCloseSubmenu(submenu) {
    if (!submenu) return;
    const trigger = this.querySelector(`[aria-controls="${CSS.escape(submenu.id)}"]`);
    submenu.hidden = true;
    trigger?.setAttribute("aria-expanded", "false");
    trigger?.focus();
  }

  ammCloneTrapFocus(event) {
    const visiblePanel = [...this.querySelectorAll("[data-amm-clone-submenu]:not([hidden])")].pop()
      || this.ammCloneDrawer.querySelector(".amm-clone-header__drawer-panel");
    const focusable = [...visiblePanel.querySelectorAll(
      'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter((element) => element.offsetParent !== null);

    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  ammCloneHandleScroll() {
    if (this.ammCloneScrollTicking) return;
    this.ammCloneScrollTicking = true;
    requestAnimationFrame(() => {
      this.ammCloneUpdateHeaderPosition();
      this.ammCloneScrollTicking = false;
    });
  }

  ammCloneSetupOffsetObserver() {
    if (!this.ammCloneSection || this.dataset.ammCloneTransparent !== "true" || !window.ResizeObserver) return;
    this.ammCloneOffsetObserver?.disconnect();
    this.ammCloneOffsetObserver = new ResizeObserver(() => this.ammCloneUpdateHeaderPosition());
    let sibling = this.ammCloneSection.previousElementSibling;
    while (sibling && sibling.classList.contains("shopify-section-group-header-group")) {
      this.ammCloneOffsetObserver.observe(sibling);
      sibling = sibling.previousElementSibling;
    }
  }

  ammCloneSetTransparentOffset() {
    if (!this.ammCloneSection || this.dataset.ammCloneTransparent !== "true") return 0;
    let offset = 0;
    let sibling = this.ammCloneSection.previousElementSibling;
    while (sibling && sibling.classList.contains("shopify-section-group-header-group")) {
      offset += sibling.getBoundingClientRect().height;
      sibling = sibling.previousElementSibling;
    }
    this.ammCloneTransparentOffset = offset;
    this.ammCloneSection.style.setProperty("--amm-clone-header-offset", `${offset}px`);
    return offset;
  }

  ammCloneUpdateHeaderPosition() {
    const offset = this.ammCloneSetTransparentOffset();
    this.ammCloneUpdateSticky(offset);
  }

  ammCloneUpdateSticky(offset = this.ammCloneTransparentOffset || 0) {
    const currentY = window.scrollY;
    const stickyMode = this.dataset.ammCloneSticky;
    const isScrolled = currentY > 12;
    this.classList.toggle("amm-clone-header--scrolled", isScrolled);
    this.ammCloneSection?.classList.toggle("amm-clone-header-section--scrolled", isScrolled);

    const fixedTop = isScrolled ? Math.max(0, offset - currentY) : 0;
    this.ammCloneSection?.style.setProperty("--amm-clone-header-fixed-top", `${fixedTop}px`);

    if (stickyMode === "on_scroll_up" && currentY > 140) {
      this.classList.toggle("amm-clone-header--hidden", currentY > this.ammCloneScrollY);
    } else {
      this.classList.remove("amm-clone-header--hidden");
    }
    this.style.transform = this.classList.contains("amm-clone-header--hidden") ? "translateY(-100%)" : "";
    this.ammCloneScrollY = currentY;
  }
}

if (!customElements.get("amm-clone-header")) {
  customElements.define("amm-clone-header", AmmCloneHeader);
}
